module.exports = new __parcel__URL__("saved_souls_level_3.4cdcb115.png").toString();